import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  list: {
    paddingBottom: '20px',

    '& ul.ant-list-items': {
      display: 'flex',
      gap: 16
    }
  },

  draggable: {
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    transform: 'rotate(4deg)',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
    cursor: 'grabbing'
  },

  scrollContainer: {
    overflowY: 'hidden',
    overflowX: 'auto'
  },

  columnDroppable: {
    zIndex: 10
  },

  card: {
    width: 290,
    height: '70vh',
    backgroundColor: token.colorBorder,

    '& .ant-card-body': {
      padding: token.padding
    }
  },

  avatar: {
    maxWidth: '150px'
  },

  column: {
    height: 'calc(70vh - 70px)',
    overflowY: 'auto',
    '& ul.ant-list-items': {
      display: 'flex',
      gap: 16
    },

    scrollbarWidth: 'thin',

    '&::-webkit-scrollbar': {
      width: '380px',
      height: '8px'
    },

    '&::-webkit-scrollbar-thumb': {
      background: token.colorWhite,
      borderRadius: '1px'
    }
  },

  leadCard: {
    maxWidth: 1200,
    margin: '0 auto',
    width: '100%',
    marginBottom: 24,

    borderRadius: 16,
    '.ant-card-head': {
      minHeight: 72,
      padding: 16,

      '.ant-card-head-title': {
        fontSize: 16
      }
    },
    '.ant-card-body': {
      padding: 16
    }
  },
  modal: {
    'ant-modal-content': {
      padding: 0
    },
    'ant-modal-body': {
      maxHeight: '80vh',
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }
}))
